import { useState } from 'react';
import { categoryList, menuList } from '../../../../../services/table.services';
import type { BulkSettlementMenuCategory } from '../types';

const fetchMenuCatalog = async (): Promise<BulkSettlementMenuCategory[]> => {
  const categoriesResponse = await categoryList({});
  const categoryItems: any[] = categoriesResponse?.data?.list || [];

  const categories = await Promise.all(
    categoryItems.map(async (category: any) => {
      const response = await menuList({ category_id: String(category?._id || '') });
      return {
        id: String(category?._id || ''),
        items: response?.data?.list || [],
        name: category?.name || '',
        nameJa: category?.name_ja || '',
      };
    }),
  );

  return categories.filter(c => c.items.length > 0);
};

export const useMenuCatalog = () => {
  const [menuCategories, setMenuCategories] = useState<BulkSettlementMenuCategory[]>([]);
  const [loading, setLoading] = useState(false);
  const [activeCategoryId, setActiveCategoryId] = useState('');

  const loadMenuCategories = async () => {
    if (loading || menuCategories.length > 0) return;
    try {
      setLoading(true);
      const categories = await fetchMenuCatalog();
      setMenuCategories(categories);
      setActiveCategoryId(categories[0]?.id || '');
    } catch (err) {
      console.error('Error loading menu catalog', err);
    } finally {
      setLoading(false);
    }
  };

  return { activeCategoryId, loadMenuCategories, loading, menuCategories, setActiveCategoryId };
};
